const getFormId = (resource: string, formId?: string) => {
    return formId || `filterForm-${resource}`;
};
export default getFormId;
